import React from 'react'
import { BulkDeleteWithConfirmButton, Datagrid } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import ReorderableList from 'ui-shared/DraggableList/ReorderableList'
import LocalizedTextField from 'ui-shared/LocalizedFields/LocalizedTextField'
import { BaseListProps } from 'ui-shared/WrappedInputs/CatalogItemBaseList'

const EventPackageSectionList: React.FC<BaseListProps> = (props) => {
  return (
    <SectionWrapper title={'resources.eventPackageSections.sectionName'}>
      <ReorderableList pagination={false} {...props} exporter={undefined}>
        <Datagrid
          rowClick="edit"
          bulkActionButtons={
            <BulkDeleteWithConfirmButton mutationMode="optimistic" />
          }
        >
          <LocalizedTextField source="name" />
        </Datagrid>
      </ReorderableList>
    </SectionWrapper>
  )
}

export default EventPackageSectionList
